import { z } from 'zod'

import { day, getNow, isBefore } from '~/astra'
import { Maintenance } from '~/hooks/tanstack-query/betterstack/utils'

export const LOCAL_STORAGE_KEY = 'betterstack-maintenance-dismissed'

const dismissRecordSchema = z.object({
    reportId: z.string(),
    latestUpdateId: z.string().optional(),
    phase: z.enum(['pre-start', 'ongoing']),
})

type DismissRecord = z.infer<typeof dismissRecordSchema>

export const getPhase = (startsAt: string): DismissRecord['phase'] => (isBefore(getNow(), day(startsAt)) ? 'pre-start' : 'ongoing')

type DismissProps = Pick<Maintenance, 'reportId' | 'latestUpdateId'> & { startsAt: string }

export const getDismissed = ({ reportId, latestUpdateId, startsAt }: DismissProps): boolean => {
    try {
        const raw = localStorage.getItem(LOCAL_STORAGE_KEY)
        if (!raw) return false

        const parsed = dismissRecordSchema.safeParse(JSON.parse(raw))
        if (!parsed.success) return false

        const dismissedRecord = parsed.data
        if (dismissedRecord.reportId !== reportId) return false
        if (dismissedRecord.latestUpdateId !== latestUpdateId) return false
        if (dismissedRecord.phase !== getPhase(startsAt)) return false

        return true
    } catch {
        return false
    }
}
